import { Minus, Plus } from "lucide-react";
import { Overline, Reveal } from "@/lib/reveal";

const QUESTIONS: ReadonlyArray<readonly [string, string]> = [
  [
    "Where do sessions take place?",
    "The Inkwell provides online therapy throughout California.",
  ],
  [
    "Who do you work with?",
    "Individuals, couples, and families.",
  ],
  [
    "What concerns can I bring?",
    "People arrive for many reasons: anxiety, relationships, family patterns, transitions, grief, identity, stress, or simply the sense that something in life needs closer attention.",
  ],
  [
    "Can I ask a question before scheduling?",
    "Yes. Questions about therapy, fit, scheduling, insurance, or private pay are welcome.",
  ],
  [
    "Which insurance plans are currently accepted?",
    "Aetna, Anthem Blue Cross, Blue Shield of California, Carelon Behavioral Health, and Cigna / Evernorth. Your insurance company ultimately determines coverage.",
  ],
];

export function Insurance() {
  return (
    <section
      id="insurance"
      data-testid="insurance-section"
      aria-labelledby="insurance-heading"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline index="04" label="Practical details" />
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                id="insurance-heading"
                className="mt-8 font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-5xl"
              >
                Insurance <em className="italic text-gold">&amp; questions.</em>
              </h2>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-stone/80">
                The Inkwell works with a number of insurance plans through
                credentialing partners. Coverage varies, so eligibility is
                verified before your first appointment. Private-pay therapy is
                also available.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.12}>
              <div className="border-t border-white/10">
                {QUESTIONS.map(([q, a], i) => (
                  <details
                    key={q}
                    data-testid={`insurance-item-${i + 1}`}
                    className="group border-b border-white/10"
                  >
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-5 py-7 font-serif text-xl font-light text-ivory transition-colors duration-300 hover:text-haint sm:text-2xl">
                      <span>{q}</span>
                      <Plus className="h-5 w-5 shrink-0 text-gold group-open:hidden" aria-hidden="true" />
                      <Minus className="hidden h-5 w-5 shrink-0 text-gold group-open:block" aria-hidden="true" />
                    </summary>
                    <p className="max-w-xl pb-7 pr-8 text-sm leading-relaxed text-stone/75 sm:text-base">
                      {a}
                    </p>
                  </details>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
